import type React from 'react';
import { SliceImageButton } from '../common/SliceImageButton';
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';
import { TYPES } from '@/engine/ioc';
import { useInjection } from 'inversify-react';
import type { SynchronizeViewsController } from './SynchronizeViewsController';
import { useEffect, useState } from 'react';

export const SynchronizeViews: React.FC<{
  descriptor: string;
  isMaximized?: boolean;
}> = ({ descriptor, isMaximized }) => {
  const controller = useInjection<SynchronizeViewsController>(TYPES.SynchronizeViewsController);

  const [isActive, setIsActive] = useState(controller.isViewsSyncActive(descriptor));

  useEffect(() => {
    const subscription = controller.subscribeToViewsSyncStateChanged(
      (activeViewDescriptor: string | undefined): void => {
        setIsActive(activeViewDescriptor === descriptor);
      }
    );
    return (): void => {
      subscription.dispose();
    };
  }, [controller, descriptor]);

  return (
    <SliceImageButton
      className={`viewsSync-icon ${descriptor}-viewsSync ${isMaximized ? 'maximized' : 'minimized'}`}
      onClick={(): void => controller.triggerViewsSync(descriptor)}
      data-testid="viewsSyncBtn"
      $isMaximized={isMaximized}
      $isActive={isActive}
    >
      <SyncAltOutlinedIcon />
    </SliceImageButton>
  );
};
